import * as duckdb from '@duckdb/duckdb-wasm';

let dbInstance = null;
let initPromise = null;

export const initDuckDB = async () => {
  if (dbInstance) return dbInstance;
  if (initPromise) return initPromise;

  initPromise = (async () => {
    try {
      const JSDELIVR_BUNDLES = duckdb.getJsDelivrBundles();
      const bundle = await duckdb.selectBundle(JSDELIVR_BUNDLES);

      const worker_url = URL.createObjectURL(
        new Blob([`importScripts("${bundle.mainWorker}");`], { type: 'text/javascript' })
      );

      const worker = new Worker(worker_url);
      const logger = new duckdb.ConsoleLogger();
      const db = new duckdb.AsyncDuckDB(logger, worker);
      await db.instantiate(bundle.mainModule);

      dbInstance = db;
      console.log('✅ DuckDB-Wasm inicializado');
      return db;
    } catch (e) {
      console.error('❌ Error inicializando DuckDB-Wasm:', e);
      throw e;
    } finally {
      initPromise = null;
    }
  })();

  return initPromise;
};

export const getDuckDB = () => {
  if (!dbInstance) {
    throw new Error('DuckDB no inicializado. Llama a initDuckDB primero.');
  }
  return dbInstance;
};
